function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SettlersActions = /*#__PURE__*/function () {
  function SettlersActions() {
    _classCallCheck(this, SettlersActions);
  }
  return _createClass(SettlersActions, [{
    key: "playerAcknowledgeNotice",
    value:
    //
    // OVERRIDE THIS FUNCTION FROM THE PARENT GAME LIBRARY TO CHANGE THE ACKNOWLEDGE TEXT TO CONTINUE
    // and override the callback
    //
    function playerAcknowledgeNotice(msg, mycallback) {
      var _this = this;
      try {
        this.game.status = "<div class=\"player-notice\">".concat(msg, "</div>");
        this.hud.updateStatus(this.game.status);
        this.hud.updateCards([]);
        this.hud.updateMenu([]);
        document.getElementById('rolldice').onclick = /*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  e.currentTarget.onclick = null;
                  _this.clearShotClock();
                  _this.setToolbarState();
                  _this.game.queue.splice(_this.game.queue.length - 1, 1);
                  _this.restartQueue();
                case 1:
                  return _context.a(2);
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }();
        if (this.loadGamePreference('settlers_play_mode') !== 0 || this.turn_limit) {
          this.setShotClock('#rolldice', 2500);
        }
      } catch (err) {
        console.error('Error with ACKWNOLEDGE notice!: ' + err);
      }
      this.halted = 1;
      this.saveGame(this.game.id);
      return 0;
    }

    //
    // Award resources for dice roll
    //
  }, {
    key: "collectHarvest",
    value: function collectHarvest(value, player_who_rolled) {
      var notice = '';
      var poor_harvest = true;
      var collection = {};
      var blocked = {};
      var _iterator = _createForOfIteratorHelper(this.game.state.cities),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var city = _step.value;
          var _player = city.player;
          var _iterator3 = _createForOfIteratorHelper(city.neighbours),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var neighboringHex = _step3.value;
              if (this.game.state.hexes[neighboringHex].value == value) {
                var _resource = this.game.state.hexes[neighboringHex].resource;
                if (this.game.state.hexes[neighboringHex].robber && _player !== this.game.state.robinhood) {
                  if (!blocked[_player]) {
                    blocked[_player] = [];
                  }
                  blocked[_player].push(_resource);
                  this.game.stats.blocked[_resource][_player - 1]++;
                  if (city.level == 2) {
                    blocked[_player].push(_resource);
                    this.game.stats.blocked[_resource][_player - 1]++;
                  }
                } else {
                  if (!collection[_player]) {
                    collection[_player] = [];
                  }
                  collection[_player].push(_resource);
                  if (this.game.player == _player) {
                    notice += this.formatResource(_resource);
                    poor_harvest = false;
                  }
                  this.game.state.players[_player - 1].resources.push(_resource);
                  this.game.stats.production[_resource][_player - 1]++;
                  this.animateHarvest(_player, _resource, neighboringHex);

                  //
                  //Double Resources for Upgraded City
                  //
                  if (city.level == 2) {
                    this.game.state.players[_player - 1].resources.push(_resource);
                    this.game.stats.production[_resource][_player - 1]++;
                    this.animateHarvest(_player, _resource, neighboringHex);
                    collection[_player].push(_resource);
                    if (this.game.player == _player) {
                      notice += this.formatResource(_resource);
                    }
                  }
                }
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.game.stats.history.push({
        roll: value,
        harvest: collection,
        bandit: blocked,
        threatened: this.game.state.threatened.slice()
      });
      var firstMsg = this.game.player == player_who_rolled ? 'you' : this.game.playerNames[player_who_rolled - 1];
      firstMsg += " rolled <span class='die_value'>".concat(value, "</span>");
      for (var player in collection) {
        var logMsg = "".concat(this.formatPlayer(player), " gains");
        collection[player].sort();
        var _iterator2 = _createForOfIteratorHelper(collection[player]),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var resource = _step2.value;
            logMsg += this.formatResource(resource);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        this.updateLog(logMsg);
      }
      if (Object.keys(collection).length == 0) {
        this.updateLog('nobody collects any resources.');
      }
      if (poor_harvest) {
        this.updateStatus("".concat(firstMsg, ": ").concat(this.randomMsg()), 1);
      } else {
        this.game.status = "<div class=\"player-notice\"><span>".concat(firstMsg, "! you gain: </span><div class=\"hud-status-card-list\">").concat(notice, "</div></div>"), 1;
        this.hud.updateStatus(this.game.status);
        this.hud.updateMenu([]);
        this.hud.updateCards([]);
      }
      if (this.animationSequence.length > 0) {
        this.runAnimationQueue(250);
        return 0;
      } else {
        return 1;
      }
    }
  }, {
    key: "buildCity",
    value: function buildCity(player, slot) {
      // remove adjacent slots
      var ad = this.returnAdjacentCitySlots(slot);
      for (var i = 0; i < ad.length; i++) {
        var d = '#' + ad[i];
        try {
          $(d).remove();
        } catch (err) {}
      }

      //Put City on GUI Board
      var divname = '#' + slot;
      var owner = 'p' + this.game.colors[player - 1];
      $(divname).removeClass('empty');
      $(this.c1.svg).hide().appendTo(divname).fadeIn(1200);
      $(divname).addClass(owner);
      var blocks_me = false;
      var newRoads = this.hexgrid.edgesFromVertex(slot.replace('city_', ''));
      if (this.game.player == player) {
        //Enable player to put roads on adjacent edges
        var _iterator4 = _createForOfIteratorHelper(newRoads),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var road = _step4.value;
            //console.log("Add ghost road from city");
            this.addRoadToGameboard(road.substring(2), road[0]);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      } else {
        //Check if new city blocks other players from expanding their roads
        var _iterator5 = _createForOfIteratorHelper(newRoads),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _road = _step5.value;
            //console.log("road: ",road);
            for (var _i = 0; _i < this.game.state.roads.length; _i++) {
              if (this.game.state.roads[_i].slot == 'road_' + _road) {
                //console.log("exists");
                if (this.game.state.roads[_i].player == this.game.player) {
                  //console.log("is mine");
                  blocks_me = true;
                }
                break;
              }
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }

      //Save City to Internal Game Logic
      //Stop if we already saved the Village
      for (var _i2 = 0; _i2 < this.game.state.cities.length; _i2++) {
        if (this.game.state.cities[_i2].slot == slot) {
          return;
        }
      }
      this.game.state.players[player - 1].towns--;

      //Check if the city is a port
      for (var p in this.game.state.ports) {
        var porttowns = this.hexgrid.verticesFromEdge(p);
        var _iterator6 = _createForOfIteratorHelper(porttowns),
          _step6;
        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var t = _step6.value;
            if ('city_' + t == slot) {
              this.game.state.players[player - 1].ports.push(this.game.state.ports[p]);
              //console.log(`Player ${player} has a ${this.game.state.ports[p]} port`);
            }
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      }

      //Let's just store a list of hex-ids that the city borders
      var neighbours = this.hexgrid.hexesFromVertex(slot.replace('city_', '')); //this.returnAdjacentHexes(slot);
      this.game.state.cities.push({
        player: player,
        slot: slot,
        neighbours: neighbours,
        level: 1
      });
      if (blocks_me) {
        console.log('undo ghost roads');
        this.displayBoard();
      }
      if (this.game.player == player) {
        this.game.state.last_city = slot;
      }
    }

    /*
    Update internal game logic to mark road as built and change class in DOM for display
    */
  }, {
    key: "buildRoad",
    value: function buildRoad(player, slot) {
      var divname = '#' + slot;
      var owner = 'p' + this.game.colors[player - 1];

      //Check if road exists in DOM and update status
      if (!document.querySelector(divname)) {
        var roadInfo = slot.split('_');
        this.addRoadToGameboard(roadInfo[2] + '_' + roadInfo[3], roadInfo[1]);
      }
      $(divname).removeClass('empty').addClass(owner);

      //Add adjacent road slots
      if (this.game.player == player) {
        var v1 = this.hexgrid.verticesFromEdge(slot.replace('road_', ''));
        var _iterator7 = _createForOfIteratorHelper(this.hexgrid.adjacentEdges(slot.replace('road_', ''))),
          _step7;
        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var road = _step7.value;
            //console.log("road: ",road);
            var v2 = this.hexgrid.verticesFromEdge(road);
            var intersection = v2.filter(function (n) {
              return v1.indexOf(n) !== -1;
            });
            //console.log(v1, v2, intersection);
            var block_me = false;
            for (var i = 0; i < this.game.state.cities.length; i++) {
              if (this.game.state.cities[i].slot == 'city_' + intersection[0]) {
                if (this.game.state.cities[i].player !== this.game.player) {
                  block_me = true;
                }
                break;
              }
            }
            if (!block_me) {
              //console.log("city_"+intersection[0]+" clear, Add ghost road from road");
              this.addRoadToGameboard(road.substring(2), road[0]);
            }
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }
      }
    }

    /*
      Every time a knight played, need to check if this makes a new largest army
    */
  }, {
    key: "checkLargestArmy",
    value: function checkLargestArmy(player) {
      var vpChange = false;
      if (this.game.state.largestArmy.player > 0) {
        //Someone already has it
        if (this.game.state.largestArmy.player != player) {
          //Only care if a diffeent player
          if (this.game.state.players[player - 1].knights > this.game.state.largestArmy.size) {
            this.game.state.largestArmy.player = player;
            this.game.state.largestArmy.size = this.game.state.players[player - 1].knights;
            vpChange = true;
          }
        } else {
          //Increase army size
          this.game.state.largestArmy.size = this.game.state.players[player - 1].knights;
        }
      } else {
        //Open to claim
        if (this.game.state.players[player - 1].knights >= 3) {
          this.game.state.largestArmy.player = player;
          this.game.state.largestArmy.size = this.game.state.players[player - 1].knights;
          vpChange = true;
        }
      }
      if (vpChange) {
        this.updateLog("".concat(this.formatPlayer(player), " claims the LARGEST ARMY"));
        this.game.queue.push("ACKNOWLEDGE\t".concat(this.game.playerNames[player - 1], " forms the largest army"));
      }
    }

    /*
    Given a city (vertex) slot w/ or w/o the city_ prefix, determine who owns a city there
    or return 0 if empty
    */
  }, {
    key: "isCityAt",
    value: function isCityAt(slot) {
      if (!slot.includes('city_')) slot = 'city_' + slot;
      var _iterator8 = _createForOfIteratorHelper(this.game.state.cities),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var city = _step8.value;
          if (city.slot == slot) return city.player;
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
      return 0;
    }

    /*
      A down and dirty recursive algorthm to find a player's longest contiguous road
    */
  }, {
    key: "checkLongestRoad",
    value: function checkLongestRoad(player) {
      //Recursive search function

      var _continuousRoad = function continuousRoad(settlers_self, currentPath, availableRoads) {
        var best = currentPath;
        if (availableRoads.length == 0) return best;
        var returnedBest,
          cityCheck,
          potTemp,
          verts = [];
        //Look in both directions
        if (currentPath.length === 1) verts = settlers_self.hexgrid.verticesFromEdge(currentPath[0]);else verts.push(settlers_self.hexgrid.directedEdge(currentPath[currentPath.length - 2], currentPath[currentPath.length - 1]));
        var _iterator9 = _createForOfIteratorHelper(verts),
          _step9;
        try {
          for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
            var v = _step9.value;
            cityCheck = settlers_self.isCityAt(v);
            if (cityCheck == player || cityCheck == 0) {
              potTemp = settlers_self.hexgrid.edgesFromVertex(v);
              var _iterator0 = _createForOfIteratorHelper(potTemp),
                _step0;
              try {
                for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
                  var potRoad = _step0.value;
                  if (availableRoads.includes(potRoad)) {
                    var newPath = currentPath.concat(potRoad);
                    var remainder = _toConsumableArray(availableRoads);
                    remainder.splice(remainder.indexOf(potRoad), 1);
                    returnedBest = _continuousRoad(settlers_self, newPath, remainder);
                    if (returnedBest.length > best.length) best = returnedBest;
                  }
                }
              } catch (err) {
                _iterator0.e(err);
              } finally {
                _iterator0.f();
              }
            }
          }
        } catch (err) {
          _iterator9.e(err);
        } finally {
          _iterator9.f();
        }
        return best;
      };

      //Determine which roads belong to player
      var playerSegments = [];
      var _iterator1 = _createForOfIteratorHelper(this.game.state.roads),
        _step1;
      try {
        for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
          var road = _step1.value;
          if (road.player == player) playerSegments.push(road.slot.replace('road_', ''));
        }
        //Starting with each, find maximal continguous path
      } catch (err) {
        _iterator1.e(err);
      } finally {
        _iterator1.f();
      }
      var longest = [];
      //console.log(`Player ${player}: ${playerSegments}`);
      for (var i = 0; i < playerSegments.length; i++) {
        var remainder = [].concat(playerSegments);
        remainder.splice(i, 1);
        var bestPath = _continuousRoad(this, Array(playerSegments[i]), remainder);
        if (bestPath.length > longest.length) longest = bestPath;
      }
      if (longest.length > this.game.state.players[player - 1].road) {
        this.game.state.players[player - 1].road = longest.length;
      }

      //Check if longest path is good enough to claim VP prize
      if (longest.length >= this.longest.min) {
        if (this.game.state.longestRoad.player > 0) {
          //Someone already has it
          if (longest.length > this.game.state.longestRoad.size) {
            if (this.game.state.longestRoad.player != player) {
              //Only care if a different player
              this.highlightRoad(player, longest, "claimed the ".concat(this.longest.name, " from ").concat(this.formatPlayer(this.game.state.longestRoad.player), " with ").concat(longest.length, " segments!"));
              this.game.state.longestRoad.player = player;
              this.game.state.longestRoad.size = longest.length;
              this.game.state.longestRoad.path = longest;
              this.game.queue.push("ACKNOWLEDGE\t".concat(this.game.playerNames[player - 1], " claimed the longest road ").concat(this.longest.icon));
            } else {
              //Increase size
              this.game.state.longestRoad.size = longest.length;
              this.game.state.longestRoad.path = longest;
              this.updateLog("".concat(this.formatPlayer(player), " extended the ").concat(this.longest.name, " to ").concat(longest.length, " segments."));
            }
            return 1;
          }
        } else {
          //Open to claim
          this.highlightRoad(player, longest, "claimed the ".concat(this.longest.name, " with ").concat(longest.length, " segments."));
          this.game.queue.push("ACKNOWLEDGE\t".concat(this.game.playerNames[player - 1], " claimed the longest road ").concat(this.longest.icon));
          this.game.state.longestRoad.player = player;
          this.game.state.longestRoad.size = longest.length;
          this.game.state.longestRoad.path = longest;
          return 1;
        }
      }
      return 0;
    }
  }, {
    key: "countResource",
    value: function countResource(player, resource) {
      var ct = 0;
      var _iterator10 = _createForOfIteratorHelper(this.game.state.players[player - 1].resources),
        _step10;
      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var i = _step10.value;
          if (i == resource) {
            ct++;
          }
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
      return ct;
    }

    /*
     *  Functions for trading
     *
     */

    //Convert Resource Object to readable string
  }, {
    key: "wishListToString",
    value: function wishListToString(stuff) {
      var offer = '';
      for (var resource in stuff) {
        if (stuff[resource] > 0) {
          if (stuff[resource] > 1) {
            offer += " and ".concat(stuff[resource], " x ").concat(resource);
          } else {
            offer += " and ".concat(resource);
          }
        }
      }
      offer = offer.length > 0 ? offer.substring(5) : '<em>nothing</em>';
      return offer;
    }
  }, {
    key: "wishListToImage",
    value: function wishListToImage(stuff) {
      var offer = '';
      for (var resource in stuff) {
        for (var i = 0; i < stuff[resource]; i++) {
          offer += "<img class=\"icon\" src=\"".concat(this.returnCardImage(resource), "\"/>");
        }
      }
      return offer;
    }

    /*
    Short circuit the simultaneous moves from an open offer trade to give player control of the game again
    */
  }, {
    key: "clearTrading",
    value: function clearTrading() {
      this.game.state.tradingOpen = false; //Flag to prevent incoming trades
      //Hack the confirms to clear the queue
      for (var i = 0; i < this.game.confirms_needed.length; i++) {
        if (this.game.confirms_needed[i]) {
          this.game.confirms_needed[i] = 0;
          if (this.game.player == i + 1) {
            this.overlay.close();
          }
        }
      }
    }
  }, {
    key: "clearAdvert",
    value: function clearAdvert() {
      this.addMove('clear_advert\t' + this.game.player);
      this.endTurn();
    }
  }, {
    key: "stopPlacementHintWave",
    value: function stopPlacementHintWave() {
      this.placement_hint_wave_token = (this.placement_hint_wave_token || 0) + 1;
      if (this.placement_hint_wave_timeout) {
        clearTimeout(this.placement_hint_wave_timeout);
        this.placement_hint_wave_timeout = null;
      }
      $(document).off('mouseenter.settlersPlacementHintWave');
      $('.placement-wave-highlight').removeClass('placement-wave-highlight');
    }
  }, {
    key: "bindPlacementHintWaveHoverStop",
    value: function bindPlacementHintWaveHoverStop(selector) {
      var settlers_self = this;
      $(document).off('mouseenter.settlersPlacementHintWave');
      $(document).on('mouseenter.settlersPlacementHintWave', selector, function () {
        var el = this;
        if (el.offsetParent === null || el.classList.contains('noselect') || !el.classList.contains('rhover') && !el.classList.contains('chover')) {
          return;
        }
        settlers_self.stopPlacementHintWave();
      });
    }
  }, {
    key: "runPlacementHintWave",
    value: function runPlacementHintWave() {
      var _this2 = this;
      var waveToken = this.placement_hint_wave_token || 0;
      var selector = this.placement_hint_wave_selector || '.rhover, .chover';
      var targets = Array.from(document.querySelectorAll(selector)).filter(function (el) {
        return el.offsetParent !== null && !el.classList.contains('noselect') && (el.classList.contains('rhover') || el.classList.contains('chover'));
      });
      if (!targets.length) {
        console.info('SETTLERS: no targets');
        this.stopPlacementHintWave();
        return;
      }
      targets.sort(function (a, b) {
        var ar = a.getBoundingClientRect();
        var br = b.getBoundingClientRect();
        return ar.left + ar.top * 0.35 - (br.left + br.top * 0.35);
      });
      var passDuration = 1000;
      var pulseDuration = 250;
      var stagger = targets.length > 1 ? passDuration / (targets.length - 1) : 0;
      targets.forEach(function (el, index) {
        setTimeout(function () {
          if (waveToken !== _this2.placement_hint_wave_token) {
            console.info('SETTLERS: waveToken mismatch');
            return;
          }
          if (!el.isConnected || el.classList.contains('noselect') || !el.classList.contains('rhover') && !el.classList.contains('chover')) {
            return;
          }
          el.classList.remove('placement-wave-highlight');
          void el.offsetWidth;
          el.classList.add('placement-wave-highlight');
          setTimeout(function () {
            if (waveToken !== _this2.placement_hint_wave_token) {
              return;
            }
            if (el.isConnected) {
              el.classList.remove('placement-wave-highlight');
            }
          }, pulseDuration);
        }, Math.round(index * stagger));
      });
    }
  }, {
    key: "schedulePlacementHintWave",
    value: function schedulePlacementHintWave() {
      var _this3 = this;
      var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10000;
      var waveToken = this.placement_hint_wave_token || 0;
      this.placement_hint_wave_timeout = setTimeout(function () {
        if (waveToken !== _this3.placement_hint_wave_token) {
          return;
        }
        _this3.runPlacementHintWave();
        _this3.schedulePlacementHintWave();
      }, delay);
    }
  }, {
    key: "startPlacementHintWave",
    value: function startPlacementHintWave() {
      var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.rhover, .chover';
      if (typeof window === 'undefined') {
        return;
      }
      this.stopPlacementHintWave();
      this.placement_hint_wave_selector = selector;
      this.bindPlacementHintWaveHoverStop(selector);
      // Run almost immediately as a visual prompt
      // Basically only for initial placement and bandit
      this.schedulePlacementHintWave(1500);
    }

    /* 
    Create an object saying what the exchange rate for each resource is
    */
  }, {
    key: "analyzePorts",
    value: function analyzePorts() {
      var resources = this.returnResources();
      var tradeCost = {};
      var minForTrade = 4;
      //console.log(this.game.state.players[this.game.player-1].ports);
      var _iterator11 = _createForOfIteratorHelper(this.game.state.players[this.game.player - 1].ports),
        _step11;
      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var i = _step11.value;
          if (i == 'any') {
            //3:1 portt
            minForTrade = 3;
          } else {
            //2:1 resource port
            tradeCost[i] = 2;
          }
        }
        //Fill in exchange rates
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
      var _iterator12 = _createForOfIteratorHelper(resources),
        _step12;
      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var r = _step12.value;
          if (!tradeCost[r]) {
            tradeCost[r] = minForTrade;
          }
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
      return tradeCost;
    }
  }, {
    key: "confirmPlacement",
    value: function confirmPlacement(slot, piece, callback) {
      this.stopPlacementHintWave();
      var cm = this.loadGamePreference('settlers_confirm_moves');
      if (cm != null) {
        this.confirm_moves = cm;
      }
      if (this.confirm_moves == 0) {
        callback();
        return;
      }
      $("#".concat(slot)).css('background-color', 'yellow');
      var settlers_self = this;
      var html = "\n          <div class=\"popup-confirm-menu\">\n            <div class=\"popup-prompt\">Place ".concat(piece, " here?</div>\n            <div class=\"action\" id=\"confirm\">yes</div>\n            <div class=\"action\" id=\"stopasking\">yes, stop asking</div>\n          </div>");
      var left = $("#".concat(slot)).offset().left + 50;
      var top = $("#".concat(slot)).offset().top + 20;
      $('.popup-confirm-menu').remove();
      $('body').append(html);
      if (left + 200 < window.innerWidth) {
        $('.popup-confirm-menu').css({
          position: 'absolute',
          top: top,
          left: left
        });
      } else {
        $('.popup-confirm-menu').css({
          position: 'absolute',
          top: top,
          right: 0
        });
      }
      $('.action').off();
      $('.action').on('click', function () {
        $('#' + slot).css('background-color', '');
        var confirmation = $(this).attr('id');
        $('.action').off();
        $('.popup-confirm-menu').remove();
        if (confirmation == 'stopasking') {
          settlers_self.confirm_moves = 0;
          settlers_self.saveGamePreference('settlers_confirm_moves', 0);
          callback();
        }
        if (confirmation == 'confirm') {
          callback();
        }
      });
    }
  }]);
}();
module.exports = SettlersActions;